import React from "react";
import Modal from "react-bootstrap/Modal";
import { WheelDetail, WheelRewardKind } from "../../types/wheel-of-luck";
import { RewardPresentation, rewardLevel } from "../../hooks/useWheelRewardCatalog";
import { formatWheelTime } from "../../utils/wheel-of-luck";
import { useAppTranslation } from "../../i18n/useAppTranslation";

type Props = {
  open: boolean;
  onClose: () => void;
  wheel: WheelDetail | null;
  serverNow: number;
  describe: (kind: WheelRewardKind) => RewardPresentation;
};

export default function WheelRewardsInfo({ open, onClose, wheel, serverNow, describe }: Props) {
  const { t, currentLanguage } = useAppTranslation(["wheel"]);
  const number = (value: number) => value.toLocaleString(currentLanguage);
  return <Modal show={open && Boolean(wheel)} onHide={onClose} centered
    aria-label={t("wheel:rewardsInfo.label")} dialogClassName="luck-rewards-modal" contentClassName="luck-rewards-content">
    {wheel && <>
      <header className="luck-rewards-header">
        <h2>{t("wheel:rewardsInfo.title")}</h2>
        {wheel.nextResetAt && <div><span>{t("wheel:rewardsInfo.resetIn")}</span><strong>{formatWheelTime(wheel.nextResetAt, serverNow,
          { language: currentLanguage, days: days => t("wheel:time.days", { days }) })}</strong></div>}
      </header>
      <ul className="luck-rewards-grid" aria-label={t("wheel:rewardsInfo.listLabel", { wheel: wheel.title })}>
        {wheel.possibleRewards.map((kind, index) => {
          const reward = describe(kind);
          const level = rewardLevel(kind);
          const quantity = kind.quantity || 0;
          // One entry per wheel slot, so two entries can be the same reward.
          return <li key={index}>
            <span>{quantity > 1 ? t("wheel:rewardQuantity", { reward: reward.name, quantity: number(quantity) }) : reward.name}
              {level > 0 && <small>{t("wheel:rewardsInfo.level", { level: number(level) })}</small>}</span>
            {reward.icon && <img src={reward.icon} alt="" data-reward-type={kind.type} width={36} height={36} />}
          </li>;
        })}
      </ul>
      {!wheel.possibleRewards.length && <p className="luck-rewards-empty">{t("wheel:rewardsInfo.empty")}</p>}
      <button type="button" className="luck-rewards-close" onClick={onClose} aria-label={t("wheel:rewardsInfo.close")}>×</button>
    </>}
  </Modal>;
}
